import React, { useCallback } from 'react'

const TextArea = ({ defaultValue, value, onChange, classNameParent, className, text, size, icon, append, ...props }) => {
  const propInput = useCallback(() => {
    return defaultValue ? { defaultValue } : { value }
  }, [defaultValue, value])

  return (<div className={classNameParent}>
    <small className="text-muted">{text}</small>
    <div className={'input-group input-group-' + size}>
      {icon ? <div className="input-group-prepend">
        <div className="input-group-text"><i className={icon}></i></div>
      </div> : ''}
      <textarea {...props} {...propInput()} onChange={onChange} className={'form-control ' + className} />
      <div className="input-group-append">
        {React.Children.toArray(append)}
      </div>
    </div>
  </div>)
}
TextArea.defaultProps = {
  size: 'lg',
  icon: '',
  classNameParent: 'col-12',
  required: false,
  append: [],
  className: '',
  onChange: () => { }
}

export default TextArea